// import React, { useState } from "react";
// import styles from "./RemoveCategoryModal.module.css";
// import API from "../../../utils/api";
// import RenderToast from "../../../components/RenderToast";

// export default function DeleteCategoryModal({ category, onClose }) {
//   const [deleting, setDeleting] = useState(false);

//   const handleDelete = async () => {
//     const token = localStorage.getItem("authToken");
//     if (!token)
//       return RenderToast({ type: "error", message: "Please login first" });

//     try {
//       setDeleting(true);
//       const formData = new URLSearchParams();
//       formData.append("action", "delete");
//       formData.append("id", category.id);

//       const res = await fetch(`${API.base}/categories.php`, {
//         method: "POST",
//         headers: { Authorization: token },
//         body: formData,
//       });
//       const data = await res.json();

//       if (data.success) {
//         RenderToast({
//           type: "success",
//           message: "Category deleted successfully!",
//         });
//         onClose();
//       } else {
//         RenderToast({
//           type: "error",
//           message: data.error || "Failed to delete category",
//         });
//       }
//     } catch {
//       RenderToast({
//         type: "error",
//         message: "Network error. Please try again.",
//       });
//     } finally {
//       setDeleting(false);
//     }
//   };

//   return (
//     <div className={styles.backdrop} onClick={onClose}>
//       <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
//         <div className={styles.header}>
//           <h3>Delete Category</h3>
//           <button className={styles.closeBtn} onClick={onClose}>
//             ✕
//           </button>
//         </div>

//         <div className={styles.content}>
//           <p>
//             Are you sure you want to delete{" "}
//             <strong>{category.categoryName}</strong>?
//           </p>
//           <p className={styles.warningText}>
//             All products inside this category (and sub-categories) will be moved
//             to <strong>Uncategorized</strong> and marked as draft.
//           </p>
//         </div>

//         <div className={styles.modalActions}>
//           <button
//             className={styles.btnSecondary}
//             onClick={onClose}
//             disabled={deleting}
//           >
//             Cancel
//           </button>
//           <button
//             className={styles.btnDelete}
//             onClick={handleDelete}
//             disabled={deleting}
//           >
//             {deleting ? "Deleting..." : "Delete"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import styles from "./RemoveCategoryModal.module.css";
import API from "../../../utils/api";
import RenderToast from "../../../components/RenderToast";

export default function RemoveCategoryModal({ category, categories, onClose }) {
  const targets = categories || (category ? [category] : []);
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    if (targets.length === 0) return;
    const token = localStorage.getItem("authToken");
    if (!token)
      return RenderToast({ type: "error", message: "Please login first" });

    try {
      setDeleting(true);
      const ids = targets.map((c) => c.id);
      const formData = new URLSearchParams();
      formData.append("action", "bulk_delete");
      formData.append("ids", JSON.stringify(ids));

      const res = await fetch(`${API.base}/categories.php`, {
        method: "POST",
        headers: { Authorization: token },
        body: formData,
      });
      const data = await res.json();

      if (data.success) {
        RenderToast({
          type: "success",
          message: `${targets.length} categor${
            targets.length > 1 ? "ies" : "y"
          } deleted successfully!`,
        });
        onClose();
      } else {
        RenderToast({
          type: "error",
          message: data.error || "Failed to delete category",
        });
      }
    } catch {
      RenderToast({
        type: "error",
        message: "Network error. Please try again.",
      });
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h3>Delete Category{targets.length > 1 ? "ies" : ""}</h3>
          <button className={styles.closeBtn} onClick={onClose}>
            ✕
          </button>
        </div>
        <div className={styles.content}>
          <p>
            Are you sure you want to delete{" "}
            {targets.length > 1 ? (
              <strong>{targets.length} categories</strong>
            ) : (
              <strong>{targets[0]?.categoryName}</strong>
            )}
            ?
          </p>
          <p className={styles.warningText}>
            All products inside these categories will be moved to{" "}
            <strong>Uncategorized</strong> and marked as draft.
          </p>
        </div>
        <div className={styles.modalActions}>
          <button
            className={styles.btnSecondary}
            onClick={onClose}
            disabled={deleting}
          >
            Cancel
          </button>
          <button
            className={styles.btnDelete}
            onClick={handleDelete}
            disabled={deleting}
          >
            {deleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
